// Interface to work with localStorage
export default {
  data() {
    return {
    }
  },
  methods: {
    initializeLSForAFeatureIfNeeded (prop, stdValues) {
      console.log('Local Storage Layer')
      console.log('initializeLSForAFeatureIfNeeded')
    try {
        this.getLSProp(prop)
      } catch (e) {
        console.log('!!!!! '+prop+' local storage is not (or erroneous) defined')
        if (typeof localStorage[prop] === 'undefined') {
          this.setLSProp(prop,stdValues)
        }
      }
    },

    setLSProp (prop, val) {
      localStorage[prop] = JSON.stringify(val)
    },

    getLSProp (prop) {
      return JSON.parse(localStorage[prop])
    },  }
}
